import { Component } from '@angular/core';

@Component({
  selector: 'app-stampscallback',
  template: '',
})
export class StampsCallbackComponent {

}
